v<template>
    <div class="d-md-none">
        <div class="row pb-4">
            <div class="col-12 col-lg-10">
                <p v-html="tabContent.tabDescription"></p>
            </div>
        </div>


        <div class="accordion accordion-flush" :id="'accordion-members-mobile-' + indexMatrix">
            <div
                v-for="(members, indexAccordion) in tabContent.memberSubSection"
                :key="'members-mobile-' + indexAccordion + '-' + tabIndex"
                class="accordion-item"
            >

                <h3
                    class="accordion-header"
                    :id="'accordion-header-' + tabIndex + indexAccordion"
                >
                    <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#accordion-content-' + tabIndex + indexAccordion"
                        aria-expanded="false"
                        :aria-controls="'accordion-content-' + tabIndex + indexAccordion"
                    >
                        {{members.section.membersTitle}}
                    </button>
                </h3>

                <div
                    :id="'accordion-content-' + tabIndex + indexAccordion"
                    class="accordion-collapse collapse"
                    :aria-labelledby="'accordion-header-' + tabIndex + indexAccordion"
                    :data-bs-parent="'#accordion-members-mobile-' + indexMatrix"
                >
                    <div class="accordion-body">
                        <div class="row">
                            <div
                                v-for="(member, index) in members.section.theMembers"
                                :key="'member-mobile' + index + '-' + tabIndex"
                                class="col-12 col-sm-6 mb-5"
                            >

                                <div class="personnel-member-card">

                                    <div class="member-card-header">
                                        <img
                                            v-if="member.member.img.url !== ''"
                                            :src="member.member.img.url"
                                            class="member-img"
                                            :alt="member.member.img.title"
                                        />
                                        <AssetLoader
                                            v-else
                                            :asset="{ asset: getRandomElementID() }"
                                            transform="?mode=crop&width=800&height=500"
                                        />
                                    </div>

                                    <div class="member-card-body">
                                        <p
                                            v-if="member.member.membersTitle !== null"
                                            class="name text-weight-semibold mb-0"
                                        >
                                            {{member.member.membersTitle}}
                                        </p>

                                        <p
                                            v-if="member.member.personnelOccupation !== null"
                                            class="text-legal mb-3"
                                        >
                                            {{member.member.personnelOccupation}}
                                        </p>

                                        <p
                                            v-if="member.member.personnelPhone !== null"
                                            class="mb-0"
                                        >
                                            {{member.member.personnelPhone + ' #' + member.member.personnelPhoneExtension}}
                                        </p>

                                        <p
                                            v-if="member.member.personnelEmail !== null"
                                            class="mb-0"
                                        >
                                            <a :href="'mailto:' + member.member.personnelEmail">{{member.member.personnelEmail}}</a>
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'PersonnelTabContentMobile',
    components: {
        AssetLoader,
    },
    props: {
        tabContent: {
            type: Object,
            required: true,
        },
        indexMatrix:{
            type: Number,
            required: false,
        },
        tabIndex:{
            type: Number,
            required: false,
        },

    },

    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
        getRandomElementID() {
            if(this.globalsIsLoaded){
                return this.globals.inisGlobalElement.inisDefaultImage.images[Math.floor(Math.random()*this.globals.inisGlobalElement.inisDefaultImage.images.length)].img.imageID;
            }


        },
    },
}
</script>
